import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SeFeFormControlHelpModule } from 'se-fe-form-control-help'
import { SeFeIconModule, seFeIconSpotJersey } from 'se-fe-icon'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiPersonaInfoModule } from '@se-po/shared-ui-persona-info'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'
import { SharedUiAddChildProfileModule } from '@se-po/shared-ui-add-child-profile'

import { ChildInfoComponent } from './child-info/child-info.component'

@NgModule({
  declarations: [
    ChildInfoComponent,
  ],
  exports: [
    ChildInfoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeFormControlHelpModule,
    SeFeIconModule.include([seFeIconSpotJersey]),
    SeFeLinkModule,
    SeFeSpinnerModule,
    SharedUiHighlightLabelModule,
    SharedUiPersonaInfoModule,
    SharedUiSetupBarModule,
    SharedUiAddChildProfileModule
  ],
})
export class SeHouseholdSetupFeatureChildInfoModule { }
